<template>
    <div>
        <el-form :inline="true" :model="batchOptForm" @submit.native.prevent>
            <el-form-item label="活码名称：">
                <el-input v-model.trim="batchOptForm.name" @keyup.enter.native="getListHandler" placeholder="支持模糊搜索"
                    clearable></el-input>
            </el-form-item>
            <el-button type="primary" class="onlyBtn" plain icon="el-icon-search"
                @click="getBatchOptListHandler($event)">查询</el-button>
            <el-button type="success" icon="el-icon-edit" class="onlyBtn" plain
                @click="showBatchChgStateHandler()">创建活码</el-button>
        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="remark" label="活码名称" width="150" align="center"></el-table-column>
            <el-table-column prop="scanUrl" label="活码链接" align="center"></el-table-column>
            <el-table-column prop="toUrl" label="跳转链接" align="center"></el-table-column>
            <!-- <el-table-column prop="scanText" label="底部文字" align="center"></el-table-column> -->
            <el-table-column prop="count" label="点击人数" width="150" align="center"></el-table-column>
            <el-table-column prop="dayCount" label="今日点击" width="150" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="150" align="center"></el-table-column>

            <el-table-column label="操作" align="center" width="280">
                <template slot-scope="scope">
                    <el-button type="text" @click="updateSacn(scope.row)">编辑活码</el-button>
                    <el-button type="text" @click="selectMa(scope.row)">查询二维码</el-button>
                    <el-button type="text" style="color:red" @click="getOptFailListHandler(scope.row.id, $event)">删除数据</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>

        <el-dialog :append-to-body="true" :title="title" :visible.sync="batchOptVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm" :model="batchOptForm" label-width="100px">

                <el-form-item label="活码名称：" prop="remark">
                    <el-input v-model="batchOptForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="跳转链接：" prop="toUrl">
                    <el-input v-model="batchOptForm.toUrl"></el-input>
                </el-form-item>
                <!-- <el-form-item label="底部文字：" prop="scanText">
                    <el-input v-model="batchOptForm.scanText" placeholder="二维码底部文字，选填"></el-input>
                </el-form-item> -->
                <el-form-item label="二维码颜色：" prop="scanColor">
                    <el-radio-group v-model="batchOptForm.scanColor">
                        <el-radio :label="1">黑色</el-radio>
                        <el-radio :label="2">绿色</el-radio>
                        <el-radio :label="3">蓝色</el-radio>
                        <el-radio :label="4">紫红色</el-radio>
                        <el-radio :label="5">藏青色</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler">确 定</el-button>
            </div>
        </el-dialog>


        <el-dialog :append-to-body="true"  title="二维码" :visible.sync="showImg" width="700px" @close="cancel" :close-on-click-modal="false">
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">注：可复制活码链接，在草料二维码（https://cli.im/）中自定义更多二维码样式</div>
            <p style="color: #F56C6C;text-align: center;" >修改完二维码图片，需要刷新页面</p>
            <div style="text-align: center; width:100%;">               
                <img  :src="scanMa" alt="" width="400px" height="500px" style="margin: 0 auto;">  
            </div>
            <div style="text-align: center; padding: 10px 0; color: #F56C6C;">活码链接  {{ scanUrl }}</div>
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" @click="copy()" class="copy_url" :data-clipboard-text="scanUrl">复制链接</el-button>
                <el-button type="danger" @click="openLink()">打开链接</el-button>
            </div>            
        </el-dialog>

    
    </div>
</template>
<script>
import { getBatchOptList, getBatchOptFailList, batchChgState, exportSimChangeStateFail } from '@/api/sim.js'
import common from '@/utils/common.js'
import Clipboard from 'clipboard';
export default {
    data() {
        return {

            batchOptForm1: {
                state: '',
                remark: '',
            },
            batchOptVisible: false,
            batchOptVisible1: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            optFailVisible: false,
            currentId_fail: '',
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            confirmExportDialogVisible: false,

            changeStateRules: {
                state: [{ required: true, message: '请选择变更状态', trigger: 'blur' }],
                remark: [{ required: true, message: '请选择输入变更原因', trigger: 'blur' }],
            },

            cardStateOption: [],

            sendFlg: false,
            sendInfo: {
                msgId: '',//模板Id
                sendId: '',
                sendName: ''
            },
            addFlag: true,
            title: '新增活码',

            batchOptForm: {
                id: '',
                remark: '',
                name: '',
                toUrl: '',
                scanColor: '',
                scanText: '',
            },
            scanMa:'',
            scanUrl:'',
            showImg:false,
        }
    },
    methods: {
          //直接打开链接
          openLink(){
            window.open(this.scanUrl)
        },
        //复制功能
        copy() {
            var clipboard = new Clipboard('.copy_url')
            clipboard.on('success', e => {
              this.$message.success('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message.success('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        },
        //改变指定列的样式
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 7) {
                // 指定列号
                return 'color:red'
            } else {
                return ''
            }
        },


        selectMa(row){
            this.scanMa=row.urlImg;
            this.scanUrl=row.scanUrl;
            this.showImg=true;
        },
        updateSacn(row) {
            this.title = '修改活码';
            this.addFlag = false;
            this.batchOptForm.id = row.id;
            this.batchOptForm.remark = row.remark;
            this.batchOptForm.toUrl = row.toUrl;
            this.batchOptForm.scanColor = row.color;
            this.batchOptForm.scanText = row.scanText;
            this.batchOptVisible = true;
        },
        importExces(id) {
            var data = {
                id: id
            }
            this.exportExcel('/mould/download/activeInfo', data);
        },
        sendSmsMsg(row) {
            this.sendInfo.sendId = row.id;
            this.sendFlg = true;
        },
        sureSendMsg() {
            common.sysRequest('lunxun/send/msg', this.sendInfo, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                    this.sendFlg = false;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },



        downPdf() {
            var link = document.createElement('a');
            link.setAttribute('download', '');
            link.href = '../../../doc/激活查询.xls';
            link.click();
        },

        cancel() {
            this.sendFlg = false;
            this.batchOptVisible = false;
            this.batchOptVisible1 = false;
            this.batchOptForm.id ='';
            this.batchOptForm.remark ='';
            this.batchOptForm.toUrl ='';
            this.batchOptForm.scanColor ='';
            this.batchOptForm.scanText ='';
        },
        getBatchOptListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.batchOptForm);
            common.sysRequest('pkg/group/select/scan', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        sureBatchChgStateHandler() {
            if (this.addFlag == true) {
                common.sysRequest('pkg/group/add/scan', this.batchOptForm, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.cancel()
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            } else {
                common.sysRequest('pkg/group/update/scan', this.batchOptForm, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.cancel()
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
            }

        },

        getOptFailListHandler(id, $event) {
            this.$confirm("删除后，将不会保留任何数据。确定要删除吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var data = {
                    id: id
                }
                common.sysRequest('pkg/group/delete/scan', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.getBatchOptListHandler();
                        this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }

                })
            })
        },
        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getBatchOptListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.upload.clearFiles();
        },

        showBatchChgStateHandler() {
            this.batchOptVisible = true;
        },
        showBatchChgStateHandler1() {
            this.batchOptVisible1 = true;
        },

        sureBatchChgStateHandler1() {
            this.$refs.batchOptForm1.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        exportSimFailHandler() {
            let data = { "updatasId": this.currentId_fail }
            exportSimChangeStateFail(data).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
                this.optFailVisible = false;
            })
        },
        handleSizeChange(val) {
            if (this.optFailVisible) {
                this.tbpg_fail.pageSize = val;
                this.getOptFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getBatchOptListHandler();
            }
        },
        handleCurrentChange(val) {
            if (this.optFailVisible) {
                this.tbpg_fail.currentPage = val;
                this.getOptFailListHandler(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getBatchOptListHandler();
            }
        }
    },
    created() {
        this.getBatchOptListHandler();

        common.sysRequest('sim/state/dict', {}, 'get').then(res => {
            if (res.data.code == 200) {
                this.cardStateOption = res.data.data;
            }
        })
    }
}
</script>
<style></style>
